<template>
    <vx-expandable-card>
        <template v-slot:header>Organizational Unit</template>
        <template v-slot:content>
            <vx-selectable
                v-model="model"
                placeholder="Search"
                :loading="loading"
                :options="orgUnits"
                :clearable="true"
                :disabled="!props.teamId"
                label="name"
                value="id"
                @search="search"
                size="lg"
                data-test="org-unit-selectable"
            ></vx-selectable>
        </template>
    </vx-expandable-card>
</template>

<script lang="ts" setup>
import { VxExpandableCard, VxSelectable } from '@voxie/frontend-components';
import { ref, watch } from 'vue';
import { adminOrgUnitsClient } from '~/services';
import debounce from '~/utils/debounce';

const props = defineProps<{
    teamId?: number | null;
}>();

const model = defineModel<{ id: number; name: string }>();
const loading = ref(false);
const orgUnits = ref<{ id: number; name: string }[]>([]);

const search = debounce(async (query?: string) => {
    if (!props.teamId) {
        orgUnits.value = [];
        return;
    }

    loading.value = true;
    try {
        const res = await adminOrgUnitsClient.listOrgUnits({
            team_id: props.teamId,
            query: query || undefined,
        });
        orgUnits.value = res.data.data.map((orgUnit: { id: number; name: string }) => ({
            id: orgUnit.id,
            name: orgUnit.name,
        }));
    } catch {
        orgUnits.value = [];
    } finally {
        loading.value = false;
    }
});

watch(
    () => props.teamId,
    (newTeamId) => {
        model.value = undefined;
        orgUnits.value = [];
        if (newTeamId) {
            search();
        }
    },
    { immediate: true }
);
</script>
